import UIkit from 'uikit';

const initAccordionCards = () => {
    const accordionLists = document.querySelectorAll('.accordion-list');
    
    const debounce = (fn, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn.apply(this, args), delay);
        };
    };

    accordionLists.forEach(list => {
        const accordionWrappers = list.querySelectorAll('.accordion-card');
    
        if (accordionWrappers.length > 0) {
            const getPaddingHeight = () => (window.innerWidth > 1024 ? 96 : 64);
            const getMobileExtra = () => (window.innerWidth < 768 ? 250 : 0);
            const getMobileGap = () => (window.innerWidth < 768 ? 0 : 32);
            let PADDING_HEIGHT = getPaddingHeight();
    
            const updateCardHeight = (card, isExpanded) => {
                const slideshow = card.querySelector('.uk-slideshow-items');
                const slides = slideshow.querySelectorAll('.accordion-slide-item');
    
                if (isExpanded) {
                    let maxContentHeight = 0;
    
                    slides.forEach(slide => (slide.style.display = 'grid'));
    
                    const contents = slideshow.querySelectorAll('.new-card__wrapper--content_text');
                    contents.forEach(content => {
                        if (content) {
                            // maxContentHeight = Math.max(maxContentHeight, content.scrollHeight);
                            
                            const titleHeight = content.querySelector('.accordion-slide-title')?.scrollHeight || 0;
                            const contentHeight = content.querySelector('.more-content')?.scrollHeight || 0;
                            const totalHeight = titleHeight + contentHeight + PADDING_HEIGHT;
    
                            if (totalHeight > maxContentHeight) {
                                maxContentHeight = totalHeight + PADDING_HEIGHT / 2 + getMobileGap();
                            }
                        }
                    });
    
                    slides.forEach(slide => slide.removeAttribute('style'));
    
                    let expandedHeight = maxContentHeight;
    
                    if (window.innerWidth > 1024 && maxContentHeight < 500) {
                        expandedHeight = maxContentHeight + 130;
                    } else if (window.innerWidth < 1024 && maxContentHeight < 300) {
                        expandedHeight = maxContentHeight + 90;
                    }
    
                    slideshow.style.height = `${expandedHeight + getMobileExtra()}px`;
    
                    window.innerWidth > 768 && card.querySelectorAll('picture').forEach(picture => {
                        picture.style.height = `${expandedHeight + getMobileExtra()}px`;
                    })
    
                    window.innerWidth > 768 && card.querySelectorAll('video').forEach(video => {
                        video.style.height = `${expandedHeight + getMobileExtra()}px`;
                    })
                } else {
                    const firstSlide = slides[0];
                    const title = firstSlide.querySelector('.accordion-slide-title');
    
                    const titleHeight = title?.scrollHeight || 0;
    
                    const collapsedHeight = titleHeight;
    
                    slideshow.style.height = `${collapsedHeight + PADDING_HEIGHT}px`;
                }
            };
            
            const handleResize = debounce(() => {
                PADDING_HEIGHT = getPaddingHeight();
                accordionWrappers.forEach((card) => {
                    const isExpanded = card.querySelector('.uk-slideshow-items')?.classList.contains('expanded');
                    updateCardHeight(card, isExpanded);
                });
            }, 150);
            
            window.addEventListener('resize', handleResize);
            window.addEventListener('orientationchange', handleResize);
            window.addEventListener('focus', () => setTimeout(handleResize, 300));
            window.addEventListener('DOMContentLoaded', () => setTimeout(handleResize, 300));
    
            accordionWrappers.forEach((card, index) => {
                const slideshow = card.querySelector('.uk-slideshow-items');
                const slides = slideshow.querySelectorAll('.accordion-slide-item');
                const button = card.querySelector('.toggle-btn');
                const slideWrapper = card.querySelector('.slide-wrapper');

                let maxTitleHeight = 0;
                slides.forEach(slide => {
                    const title = slide.querySelector('.accordion-slide-title');
                    if (title) {
                        maxTitleHeight = Math.max(maxTitleHeight, title.scrollHeight);
                    }
                });
                slideshow.style.height = `${maxTitleHeight + PADDING_HEIGHT}px`;
            
                const expand = () => {
                    slideshow.classList.add('expanded');
                    updateCardHeight(card, true);
                    const firstSlide = slideshow.querySelector('.accordion-slide-item');
                    const firstTitle = firstSlide?.querySelector('.accordion-slide-title')?.textContent;
                    const formattedTitle = firstTitle.replace(/\s+/g, '-');
                    button?.setAttribute('data-gtm', `gtm—accordion—close—${formattedTitle}`);
                };
            
                const collapse = () => {
                    slideshow.classList.remove('expanded');
                    UIkit.slideshow(card.querySelector('.slide-wrapper')).show(0);
                    updateCardHeight(card, false);
                    const activeSlide = card.querySelector('.uk-slideshow-items > .uk-active');
                    const title = activeSlide?.querySelector('.accordion-slide-title')?.textContent;
                    const formattedTitle = title.replace(/\s+/g, '-');
                    button?.setAttribute('data-gtm', `gtm—accordion—open—${formattedTitle}`);
                };
            
                button?.addEventListener('click', (e) => {
                    e.stopPropagation();
                    slideshow.classList.contains('expanded') ? collapse() : expand();
                });
            
                slideshow.addEventListener('click', () => {
                    if (!slideshow.classList.contains('expanded')) {
                        expand();
                    }
                });
            
                if (slideWrapper) {
                    UIkit.util.on(slideWrapper, 'itemshown', () => {
                        if (!slideshow.classList.contains('expanded')) {
                            collapse();
                        }
                    });

                    UIkit.slideshow(slideWrapper, {
                        animation: 'none'
                    });

                    slideWrapper.addEventListener('beforeitemshow', (e) => {
                        const image = e.target.querySelector('.overlay-media');
                        const text = e.target.querySelector('.new-card__wrapper--content_text');

                        if (image) {
                            image.classList.remove('opacity-animation');
                            void image.offsetWidth; // reflow to restart animation
                            image.classList.add('opacity-animation');
                        }

                        if (text) {
                            text.classList.remove('slide-from-left-animation');
                            void text.offsetWidth; // reflow to restart animation
                            text.classList.add('slide-from-left-animation');
                        }
                        
                        const nextSlide = e.target;
                        const nextTitle = nextSlide?.querySelector('.accordion-slide-title')?.textContent || '';
                        const formattedTitle = nextTitle.replace(/\s+/g, '-');

                        button?.setAttribute('data-gtm', `gtm—accordion—close—${formattedTitle}`);

                        const arrows = card.querySelectorAll('.slideshow-controls [gtm-data]');
                        arrows.forEach((arrow) => {
                            const direction = arrow.getAttribute('uk-slideshow-item'); // 'next' or 'previous'
                            arrow.setAttribute('gtm-data', `gtm—accordion-arrow--${direction}--${formattedTitle || 'unknown'}`);
                        });
                    });
                }
            
                if (index === 0) {
                    setTimeout(() => {
                        expand();
                    }, 0)
                }
            });
        }
    })
};

export default initAccordionCards;